module.exports = __webpack_public_path__ + "static/media/cb2c5516.jpg";